export default {
  PayBuild: 'Pay/Pay.Build'
}